import { keepPreviousData, useQuery } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { onError } from "util/conditional/onError";
export const eventsUrl = (id) => qualifyUrl(`/events/${id}`);
const fetchEvent = (eventId) => fetch("GET", eventsUrl(eventId)).then((data) => data.event);
const useEventById = (eventId, { onErrorHandler } = {}) => {
  const { data, refetch, isLoading, isFetched } = useQuery({
    queryKey: ["event-by-id", eventId],
    queryFn: () => onError(fetchEvent(eventId), (errorThrown) => {
      if (onErrorHandler) onErrorHandler(errorThrown);
      UserNotification.error(
        `Loading event or alert failed with status: ${errorThrown}`,
        "Could not load event or alert"
      );
    }),
    placeholderData: keepPreviousData,
    enabled: !!eventId
  });
  return {
    data,
    refetch,
    isLoading,
    isFetched
  };
};
export default useEventById;
